<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">上传扫描文件图片</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">

        <el-row>

            <el-col :span="24" class="item">
              <div>文件图片</div>
              <el-upload
                  action=""
                  :limit="limitCountStart"
                  :before-upload="beforeUploadStart"
                  :on-preview="handlePictureCardPreviewStart"
                  :on-change="handleChangeStart"
                  :on-success="imgSuccessStart"
                  :http-request="uploadHttpStart"
                  list-type="picture-card"
                  :on-remove="handleRemoveStart"
                  :class="{disabled:uploadDisabledStart}"
                  :file-list="fileListStart">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :modal-append-to-body="false" :visible.sync="imgVisibleStart" width="30%">
                <img width="100%" :src="dialogImageUrlStart" alt="图片未找到"/>
              </el-dialog>
            </el-col>

        </el-row>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'GetGood',
  data() {
    return {

      loading: false,

      escanRecordCode:'',

      imgsStart:[],

      limitCountStart: 20,
      uploadDisabledStart: false,
      //是否显示预览图片
      imgVisibleStart: false,
      //预览图片url
      dialogImageUrlStart: "",
      fileListStart: [],


    }
  },
  components:{

  },
  methods: {
    init(escanRecordCode){

      this.escanRecordCode = escanRecordCode;

      this.fileListStart = [];
      this.uploadDisabledStart=false;
      this.imgsStart = [];

    },
    closeSelf() {
      this.$emit("closeMe");
    },


    confirm(){

      for(let i=0;i<this.fileListStart.length;i++){
        this.imgsStart.push({"imgPath":this.fileListStart[i].url.replace(this.$imgUrl,''),sort:i+1});
      }

      if(this.imgsStart.length==0){
        this.$message.info("先上传图片")
        return;
      }


      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"EScanRecord/AddImg",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          escanRecordCode:this.escanRecordCode,
          arr:this.imgsStart,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.closeSelf();
          this.$emit("resultSuccess");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },


    // 图片上传成功 不执行 del
    imgSuccessStart(response, file, fileList) {
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;
    },

    // 预览图片
    handlePictureCardPreviewStart(file) {
      this.imgVisibleStart = true;
      this.dialogImageUrlStart = file.url;
    },
    // 删除图片
    handleRemoveStart(file, fileList) {
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;

      let Pics = this.fileListStart;
      Pics.forEach((item, index) => {
        if (file.url == item.url) {
          Pics.splice(index, 1);
        }
      })
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },

    //图片更改
    handleChangeStart(file,fileList) {
      this.fileListStart.push({uid:file.uid,name:file.name,url:''});
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;
    },

    beforeUploadStart(){

    },
    uploadHttpStart(file) {

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append("time",this.startTime);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;

      this.$axios.post(this.$shopUrl+'Upload/ImgsStaff',fd).then(function(res){
        //console.log(res);

        if(res.data.error == 0){
          for(let i=0;i<that.fileListStart.length;i++){
            if(that.fileListStart[i].uid == file.file.uid){
              that.fileListStart[i].url = that.$imgUrl+ res.data.data.path;
            }
          }
        }
        else if(res.data.error == 1){

          that.$message.error(res.data.message);

          let Pics = that.fileListStart;
          Pics.forEach((item, index) => {
            if (file.file.uid == item.uid) {
              Pics.splice(index, 1);
            }
          })

        }

        that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;

      }).catch(error => {
        console.log(error);

        let Pics = that.fileListStart;
        Pics.forEach((item, index) => {
          if (file.file.uid == item.uid) {
            Pics.splice(index, 1);
          }
        })

        that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;


      })


    },



  }
}


</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
